import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import StoreMappingModal from '../components/StoreMappingModal';

export const getStoreMappingModalConfig = ({
  availableStores,
  setSelectedAvailableStores,
  selectedAvailableStores,
  handleCallToCreateAssociation,
  price,
}) => ({
  type: 'actionWhite',
  isFullscreen: true,
  title: i18next.t('ADMIN.SUPPLIER_PRODUCTS.CREATE_STORE_MAPPING_TITLE'),
  icon: '/images/inpulse/add-black-small.svg',
  customPadding: '24px 24px 0px 24px',
  component: StoreMappingModal,
  data: {
    availableStores,
    setSelectedAvailableStores,
    price,
  },
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_SAVE_BUTTON(),
      handleClick: () => {
        handleCallToCreateAssociation(selectedAvailableStores);
      },
    },
  ],
});

export default getStoreMappingModalConfig;
